<template>

	<!-- 导航栏 -->
	<div class="indexNavOut Vheader">
		<div class="indexNav">
			<div class="fl">迪彩集团 <div style="display: inline-block;" v-if="this.$store.state.login"><span class="username">经销商名称:{{this.$store.state.fullname}}</span>
					<router-link to="resetpwd" class='change_password'>修改密码</router-link> </div>
			</div>
			<ul class="navLi fr" v-if="this.$store.state.login">
				<li>
					<router-link to="cat">商品分类</router-link>
				</li>
				<li >
					<router-link to="address">收货地址</router-link>
				</li>
				<li >
					<router-link to="order-list">我的订单</router-link>
				</li>
				<li class="relative">
					<router-link to="cart">购物车</router-link><div class="circle-cart" id="circle-cart-count"></div>
				</li>
				<li @click="loginExit ()">
					<router-link to="login" replace>退出</router-link>
				</li>
			</ul>
			<ul class="navLi fr" v-else>
				<li>
					未登录
				</li>
			</ul>
		</div>
	</div>

</template>

<script>
	import https from '@/https.js';
	export default {
		name: 'Vheader',
		data() {
			return {
				fullname: '',
				cartCount:0
			}
		},
		created: function() {
			this.getusername();
		},
		methods: {
			loginExit: function() {
				localStorage.removeItem('authorization');
				localStorage.removeItem('CLIENT_EXPIRES');
				localStorage.removeItem('fullname');
				this.fullname = '';
			},
			getusername:function(){
				var fullname = localStorage.getItem('fullname');
				this.fullname = fullname || '';
			},
			getCartItemsCount: function() {
				var me = this;
				https.fetchGet('/pc/service/trade/cart/index').then((res) => {
					if (res.data.success) {
						var data = res.data.content;
						me.cartCount = data.rows.length;
						document.getElementById("circle-cart-count").innerHTML=me.cartCount;
					}
				}).catch(err => {
					console.log(err)
				})
			},

		}
	}
</script>

<style>
	.relative{position: relative;}
	.circle-cart{   color: #ffffff;
    background-color: red;
    position: absolute;
    top: 12px;
    right: -15px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 14px;
    line-height: 20px;
    text-align: center;}
</style>



// WEBPACK FOOTER //
// src/views/header.vue